export function unique() {
  return btoa(
    Math.ceil(Math.random() * 1000 + 10) +
      Date.now() +
      Math.ceil(Math.random() * 1000 + 10) +
      ""
  );
}
